import "./App.css";
import Home from "./pages/Home";
import Info from "./pages/Info";
import Profile from "./pages/Profile";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import { createContext, useState, useEffect, useRef } from "react";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const apiUrl = process.env.REACT_APP_API_URL;
const supabase = createClient(supabaseUrl, supabaseKey);

export const useSupabase = () => {
  return supabase;
};

export const AuthContext = createContext({});

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState(null, "", location.pathname);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

function App() {
  const [session, setSession] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const didMount = useRef(false);
  // const action = useNavigationType();
  // const location = useLocation();
  const supabase = useSupabase();
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    setIsFetching(false);
    console.log("Session changed:", session);
  }, [session]);

  return (
    <AuthContext.Provider
      value={{
        isFetching: isFetching,
        session: session,
        user: session?.user,
        apiUrl: apiUrl,
      }}
    >
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/info" element={<Info />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
